import React, { useState } from "react";
import Modal from "../../components/common/Modal";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";


const Results = () => {
    const resultData = [
        {
            id: 1,
            academicYear: "2025-26",
            exam: "Semester 1",
            curriculum: "CBSE",
            className: "10th A",
            section: "A",
            rollNo: "101",
            studentName: "Rahul Sharma",
            fatherName: "Ramesh Sharma",
            attendance: "96%",
            subjects: [
                {
                    name: "Telugu",
                    max: 100,
                    marks: 88
                },

                {
                    name: "Hindi",
                    max: 100,
                    marks: 90
                },

                {
                    name: "English",
                    max: 100,
                    marks: 92
                },

                {
                    name: "Mathematics",
                    max: 100,
                    marks: 95
                },

                {
                    name: "Science",
                    max: 100,
                    marks: 91
                },

                {
                    name: "Social",
                    max: 100,
                    marks: 86
                }

            ],
            rank: 2,
            remarks: "Excellent Performance"
        },
        {
            id: 2,
            academicYear: "2025-26",
            exam: "Semester 1",
            curriculum: "CBSE",
            className: "10th A",
            section: "A",
            rollNo: "102",
            studentName: "Vignika",
            fatherName: "Venkatesh",
            attendance: "94%",
            subjects: [

                {
                    name: "Telugu",
                    max: 100,
                    marks: 78
                },

                {
                    name: "Hindi",
                    max: 100,
                    marks: 80
                },

                {
                    name: "English",
                    max: 100,
                    marks: 85
                },

                {
                    name: "Mathematics",
                    max: 100,
                    marks: 88
                },

                {
                    name: "Science",
                    max: 100,
                    marks: 82
                },

                {
                    name: "Social",
                    max: 100,
                    marks: 79
                }
            ],
            rank: 5,
            remarks: "Good"
        }
    ];

    const [filters, setFilters] = useState({
        academicYear: "",
        exam: "",
        curriculum: "",
        className: "",
        section: ""

    });
    const [search, setSearch] = useState("");
    const [selectedStudent, setSelectedStudent] = useState(null);
    const calculateResult = (student) => {
        let total = 0;
        let max = 0;
        student.subjects.forEach(sub => {
            total += sub.marks;
            max += sub.max;
        });
        let percentage = (total / max) * 100;
        let grade;
        if (percentage >= 90)
            grade = "A+";

        else if (percentage >= 80)
            grade = "A";

        else if (percentage >= 70)
            grade = "B";

        else if (percentage >= 60)
            grade = "C";

        else
            grade = "D";
        return {
            total,
            max,
            percentage: percentage.toFixed(2),
            grade,
            status:
                percentage >= 40
                    ?
                    "Pass"
                    :
                    "Fail"

        };
    };

    const filteredResults = resultData.filter(item => {
        return (
            (filters.academicYear === "" ||
                item.academicYear === filters.academicYear)
            &&
            (filters.exam === "" ||
                item.exam === filters.exam)
            &&
            (filters.curriculum === "" ||
                item.curriculum === filters.curriculum)
            &&
            (filters.className === "" ||
                item.className === filters.className)
            &&
            (filters.section === "" ||
                item.section === filters.section)
            &&
            item.studentName
                .toLowerCase()
                .includes(
                    search.toLowerCase()
                )
        );
    });

    const downloadClassResultPDF = () => {
        if (filteredResults.length === 0) {
            alert("No students available to download");
            return;
        }
        const doc = new jsPDF("landscape");
        doc.setFontSize(16);
        doc.text(
            "Student Result Report",
            140,
            15
        );
        doc.setFontSize(11);
        doc.text(
            `Academic Year : ${filters.academicYear || "All"}`,
            15,
            30
        );
        doc.text(
            `Exam : ${filters.exam || "All"}`,
            15,
            38
        );
        doc.text(
            `Class : ${filters.className || "All"}`,
            15,
            46
        );
        doc.text(
            `Section : ${filters.section || "All"}`,
            15,
            54
        );

        const tableRows = filteredResults.map(
            (student, index) => {
                const result =
                    calculateResult(student);
                return [
                    index + 1,
                    student.rollNo,
                    student.studentName,
                    student.className,
                    student.section,
                    result.total + "/" + result.max,
                    result.percentage + "%",
                    result.grade,
                    result.status
                ];
            });



        autoTable(doc, {
            startY: 65,
            head: [
                [
                    "#",
                    "Roll No",
                    "Student Name",
                    "Class",
                    "Section",
                    "Marks",
                    "Percentage",
                    "Grade",
                    "Status"
                ]
            ],
            body: tableRows,
            theme: "grid",
            styles: {
                fontSize: 10
            }
        });

        doc.save(
            "Class_Result_Report.pdf"
        );
    };

    return (
        <div className=" mt-4">
            <h3 className="mb-4">Student Results </h3>

            {/* FILTER CARD */}

            <div className="card mb-4">


                <div className="card-header d-inline">
                    <i className="bi bi-funnel-fill me-2"></i>
                    Result Filters
                </div>



                <div className="card-body">


                    <div className="row g-3">



                        <div className="col-md-2">

                            <select

                                className="form-select"

                                onChange={(e) =>

                                    setFilters({

                                        ...filters,

                                        academicYear: e.target.value

                                    })

                                }

                            >

                                <option value="">
                                    Year
                                </option>

                                <option>
                                    2025-26
                                </option>


                            </select>


                        </div>




                        <div className="col-md-2">

                            <select

                                className="form-select"

                                onChange={(e) =>

                                    setFilters({

                                        ...filters,

                                        exam: e.target.value

                                    })

                                }

                            >

                                <option value="">
                                    Exam
                                </option>


                                <option>
                                    Semester 1
                                </option>

                                <option>
                                    Final Exam
                                </option>


                            </select>

                        </div>






                        <div className="col-md-2">

                            <select

                                className="form-select"

                                onChange={(e) =>

                                    setFilters({

                                        ...filters,

                                        curriculum: e.target.value

                                    })

                                }

                            >


                                <option value="">
                                    Curriculum
                                </option>


                                <option>
                                    CBSE
                                </option>


                                <option>
                                    State Board
                                </option>


                            </select>


                        </div>






                        <div className="col-md-2">

                            <select

                                className="form-select"

                                onChange={(e) =>

                                    setFilters({

                                        ...filters,

                                        className: e.target.value

                                    })

                                }

                            >


                                <option value="">
                                    Class
                                </option>

                                <option>
                                    10th A
                                </option>


                            </select>


                        </div>






                        <div className="col-md-2">

                            <select

                                className="form-select"

                                onChange={(e) =>

                                    setFilters({

                                        ...filters,

                                        section: e.target.value

                                    })

                                }

                            >


                                <option value="">
                                    Section
                                </option>


                                <option>
                                    A
                                </option>


                                <option>
                                    B
                                </option>


                            </select>


                        </div>






                        <div className="col-md-2">


                            <input

                                className="form-control"

                                placeholder="Search"

                                onChange={(e) =>

                                    setSearch(e.target.value)

                                }

                            />


                        </div>



                    </div>


                </div>


            </div>

            {/* RESULT TABLE */}

            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5>Result List </h5>
                    <button  className="btn-add"  onClick={downloadClassResultPDF}>
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                        Download Class Result PDF
                    </button>
                </div>

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Roll No</th>
                                    <th>Student</th>
                                    <th>Class</th>
                                    <th>Total</th>
                                    <th>%</th>
                                    <th>Grade</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filteredResults.map((student, index) => {
                                        let result = calculateResult(student);
                                        return (
                                            <tr key={student.id}>
                                                <td>{index + 1}</td>
                                                <td>{student.rollNo}</td>
                                                <td>{student.studentName}</td>
                                                <td> {student.className}</td>
                                                <td>
                                                    {result.total}/{result.max}

                                                </td>


                                                <td>
                                                    {result.percentage}%
                                                </td>


                                                <td>

                                                    <span className="badge bg-info">

                                                        {result.grade}

                                                    </span>


                                                </td>


                                                <td>

                                                    <span className="badge bg-success">

                                                        {result.status}

                                                    </span>

                                                </td>



                                                <td>


                                                    <button

                                                        className="btn btn-sm btn-primary"

                                                        onClick={() =>

                                                            setSelectedStudent(student)

                                                        }

                                                    >

                                                        <i className="bi bi-eye-fill"></i>  View

                                                    </button>


                                                </td>



                                            </tr>

                                        )

                                    })

                                }



                            </tbody>


                        </table>

                    </div>
                </div>
            </div>


            {/* RESULT VIEW MODAL */}



            <Modal

                show={selectedStudent !== null}

                onClose={() => setSelectedStudent(null)}

                title={
                    "Student Result Card"
                }

                size="xl"

            >


                {

                    selectedStudent &&

                    <>


                        <div className="row mb-3">


                            <div className="col-md-6">

                                <h5>

                                    <i className="bi bi-person-circle me-2"></i>

                                    {selectedStudent.studentName}

                                </h5>


                                <p>

                                    <strong>Roll No:</strong>
                                    {" "}
                                    {selectedStudent.rollNo}

                                    <br />


                                    <strong>Class:</strong>
                                    {" "}
                                    {selectedStudent.className}


                                    <br />


                                    <strong>Section:</strong>
                                    {" "}
                                    {selectedStudent.section}


                                    <br />


                                    <strong>Attendance:</strong>
                                    {" "}
                                    {selectedStudent.attendance}


                                </p>


                            </div>



                            <div className="col-md-6 text-end">


                                <button

                                    className="btn btn-success"

                                    onClick={() => window.print()}

                                >


                                    <i className="bi bi-printer-fill me-2"></i>

                                    Print Result


                                </button>


                            </div>


                        </div>






                        <table className="table table-bordered table-striped">


                            <thead>


                                <tr>

                                    <th>
                                        Subject
                                    </th>

                                    <th>
                                        Maximum Marks
                                    </th>

                                    <th>
                                        Obtained Marks
                                    </th>

                                    <th>
                                        Grade
                                    </th>


                                </tr>


                            </thead>




                            <tbody>


                                {


                                    selectedStudent.subjects.map(sub => (


                                        <tr key={sub.name}>


                                            <td>

                                                {sub.name}

                                            </td>


                                            <td>

                                                {sub.max}

                                            </td>


                                            <td>

                                                {sub.marks}

                                            </td>


                                            <td>


                                                {

                                                    sub.marks >= 90
                                                        ?
                                                        "A+"
                                                        :
                                                        sub.marks >= 80
                                                            ?
                                                            "A"
                                                            :
                                                            sub.marks >= 70
                                                                ?
                                                                "B"
                                                                :
                                                                sub.marks >= 40
                                                                    ?
                                                                    "C"
                                                                    :
                                                                    "F"

                                                }


                                            </td>



                                        </tr>


                                    ))


                                }


                            </tbody>


                        </table>







                        <div className="card bg-light mt-3">


                            <div className="card-body">


                                <div className="row text-center">



                                    <div className="col-md-3">


                                        <h6>Total Marks</h6>


                                        <h5>

                                            {
                                                calculateResult(selectedStudent).total
                                            }

                                            /

                                            {
                                                calculateResult(selectedStudent).max
                                            }


                                        </h5>


                                    </div>





                                    <div className="col-md-3">


                                        <h6>Percentage</h6>


                                        <h5>

                                            {
                                                calculateResult(selectedStudent).percentage
                                            }%

                                        </h5>


                                    </div>





                                    <div className="col-md-3">


                                        <h6>Grade</h6>


                                        <h5>

                                            <span className="badge bg-info">

                                                {
                                                    calculateResult(selectedStudent).grade
                                                }

                                            </span>


                                        </h5>


                                    </div>





                                    <div className="col-md-3">


                                        <h6>Status</h6>


                                        <h5>

                                            <span className="badge bg-success">

                                                {
                                                    calculateResult(selectedStudent).status
                                                }

                                            </span>


                                        </h5>


                                    </div>



                                </div>


                            </div>


                        </div>



                    </>

                }


            </Modal>
        </div>
    );
};


export default Results;